/* 回收云手机 */
import {action} from 'mobx';
import {deviceRecycle} from '@/services/Home';
import DeviceStore from '@/stores/device';
import * as R from 'ramda';
import {message} from 'antd';

class RecoveryStore {
  
  @action async deviceRecycle(cid?: string) {
    
    const ids = cid ? DeviceStore.DeviceOperation.RebootStore.selectedId(cid) :
      DeviceStore.DeviceOperation.RebootStore.selectedIds
    
    const [error] = await deviceRecycle({
      ids:  R.join(',', ids)
    });
    
    if(error) return false;
    
    message.success('操作成功')
    
    return true
    
  }
  
}

export default RecoveryStore;
